<template>
    <base-step :step="step"
               :steps="steps">
    </base-step>
</template>

<script>
    import { mapGetters } from 'vuex';
    import BaseStep from '@/components/main/pages/base/BaseStep';

    export default {
        name: 'CampRegistrationStep',
        components: {BaseStep},
        data() {
            return {
                steps: [
                    () => import(/* webpackChunkName: 'camps' */ './Step1'),
                    () => import(/* webpackChunkName: 'camps' */ './Step2'),
                    () => import(/* webpackChunkName: 'camps' */ './Step3'),
                    () => import(/* webpackChunkName: 'camps' */ './Step4')
                ]
            }
        },
        computed: {
            ...mapGetters({
                step: 'campCreationStep'
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/main/pages/camp-form/CampRegistrationStep.vue